import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=4056d5a6"
var script = {}
import style0 from "./frame.vue?vue&type=style&index=0&id=4056d5a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports